export function CostCalculateByTime(time, rate) {
  console.log(time,"5555")
  const [hours, minutes] = time.split(":").map(Number);

  const totalHours = hours + minutes / 60;
  const totalCost = totalHours * rate;

  return totalCost;
}
